import React from 'react';
import { Link } from 'react-router-dom';
import useElemSize from '../../hooks/useElemSize';
import useMain from '../../hooks/useMain';
import Image from '../common/image';
import ModeToggler from '../common/modeToggler';

const Header = ({ onTogglerClicked }) => {
	const [ref] = useElemSize('header');
	const { theme } = useMain();

	return (
		<header
			ref={ref}
			className={`navbar navbar-${theme} px-2 dashboard-header d-flex align-items-stretch d-md-none`}>
			<Link
				className='col-4'
				to='/'>
				<Image
					className='w-100'
					fileName={`logo/${theme}.webp`}
				/>
			</Link>

			<div className='col-6 d-flex justify-content-end align-items-center'>
				<div>
					<ModeToggler />
				</div>
				<button
					onClick={onTogglerClicked}
					className='navbar-toggler collapsed ms-2'
					type='button'>
					<span className='navbar-toggler-icon'></span>
				</button>
			</div>
		</header>
	);
};

export default Header;
